import createRoutineSlice from '../createRoutineSlice';
import {
    AnyRecord,
    CreateRoutineSliceArgument,
    ReducersMapExtendable,
} from '../createRoutineSlice/createRoutineSlice.types';

import { EnhancedState, PaginationConfig } from './createEnhancedRoutineSlice.types';
import addPagination from './addPagination';
import getPaginationReducerMapMixin from './getPaginationReducerMapMixin';

/**
 * A function to create a routine slice with `initialState`, enhanced with
 * pagination props, and `routineReducers`, ehhanced with pagination routines.
 *
 * @deprecated We're moving to native redux-toolkit usage, without routines or saga.
 * This will be kept for as long as needed, but I want deprecation to be visible.
 */
export default function createEnhancedRoutineSlice<
    N extends string, // name
    S extends AnyRecord, // state
    RM extends undefined | ReducersMapExtendable<S, string>, // routine reducers map
    RMEnhanced extends undefined | ReducersMapExtendable<EnhancedState<S>, string>,
    E extends ReadonlyArray<string> | undefined = undefined, // routine names in extraRoutines
>({
    // pagination config:
    defaultSortParam,
    sortParamToUpperCase,

    // createRoutineSlice config:
    initialState,
    routineReducers,
    ...rest
}: Pick<CreateRoutineSliceArgument<N, S, RM, E>, 'initialState'> &
    PaginationConfig &
    Omit<CreateRoutineSliceArgument<N, EnhancedState<S>, RMEnhanced, E>, 'initialState'>) {
    return createRoutineSlice({
        initialState: addPagination(initialState),
        routineReducers: {
            ...getPaginationReducerMapMixin<undefined>({
                defaultSortParam,
                sortParamToUpperCase,
            }),
            ...(routineReducers as RMEnhanced extends undefined
                ? Record<never, never>
                : RMEnhanced),
        },
        ...rest,
    });
}
